import React, { useEffect, useState } from 'react';
import Pagination from '../../../components/pagination';
import { searchReviews, updateReview } from '../../../api/sportaloka-client';
import { format } from 'date-fns';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';

function ReviewTable() {
  const [paginationOptions, setPaginationOptions] = useState({
    page: 1,
    limit: 10
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [data, setData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);

  const handlePageChange = (page) => {
    setPaginationOptions({ ...paginationOptions, page });
  };

  useEffect(() => {
    getData();
  }, [paginationOptions]);

  const getData = async () => {
    try {
      setLoading(true);
      setError(false);
      setData([]);
      const query = new URLSearchParams({
        page: paginationOptions.page,
        limit: paginationOptions.limit
      }).toString();
      const response = await searchReviews(query);
      const responseData = response.data.data.data;
      setData(responseData);
      setTotalRows(response.data.data.total_rows);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setError(true);
    }
  };

  const showMessage = (message) => {
    Swal.fire({
      html: `<p class="text-left mt-20">${message}</p>`,
      showCloseButton: true,
      showConfirmButton: false
    });
  };

  const handleUpdate = async (id, is_approved) => {
    Swal.fire({
      title: 'Apakah anda yakin?',
      text: 'Aksi ini tidak dapat dikembalikan',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Tetap lanjutkan!',
      cancelButtonText: 'Batalkan'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setLoading(true);
          setData([]);
          await updateReview(id, is_approved);
          await getData();
          Swal.fire({
            title: 'Berhasil!',
            text: `Status berhasil diubah`,
            icon: 'success',
            confirmButtonText: 'Tutup'
          });
          setLoading(false);
        } catch (error) {
          Swal.fire({
            title: 'Gagal!',
            text: `Periksa koneksi internet anda`,
            icon: 'error',
            confirmButtonText: 'Tutup'
          });
          setLoading(false);
        }
      }
    });
  };

  return (
    <div className="overflow-scroll scroll-bar-1 mb-20">
      <table className="table-2 col-12">
        <thead>
          <tr>
            <th style={{ width: '15%' }}>Penulis</th>
            <th style={{ width: '15%' }}>Booking Code</th>
            <th style={{ width: '15%' }}>Status</th>
            <th style={{ width: '15%' }}>Gambar</th>
            <th style={{ width: '15%' }}>Pesan</th>
            <th style={{ width: '15%' }}>Tanggal Dibuat</th>
            <th className="text-center">Aksi</th>
          </tr>
        </thead>
        <tbody>
          {loading && (
            <tr>
              <th className="text-center" colSpan="6">
                Loading data...
              </th>
            </tr>
          )}
          {!loading && data && data.length === 0 && !error && (
            <tr>
              <th className="text-center" colSpan="6">
                No data
              </th>
            </tr>
          )}
          {error && (
            <tr>
              <th className="text-center" colSpan="6">
                Tidak ada koneksi internet,{' '}
                <span className="text-danger cursor-pointer" onClick={getData}>
                  Coba kembali
                </span>
              </th>
            </tr>
          )}
          {data &&
            data.map((row) => (
              <tr key={row.id}>
                <td>{row.user.fullname}</td>
                <td>
                  <Link
                    to={`/bookings/detail/${row.booking.id}`}
                    target="_blank"
                    className="fw-600 text-primary">
                    {row.booking.booking_code}
                  </Link>
                </td>
                <td>
                  <span
                    className={`${row.is_approved === null ? 'bg-alert' : row.is_approved ? 'bg-success text-white' : 'bg-warning'} px-2 py-1 rounded-lg fw-600 text-12`}>
                    {row.is_approved === null ? 'BARU' : row.is_approved ? 'DISETUJUI' : 'DITOLAK'}
                  </span>
                </td>
                <td>
                  {row.image && (
                    <Link to={row.image} target="_blank" className="fw-600 text-primary">
                      Lihat Gambar
                    </Link>
                  )}
                </td>
                <td>
                  <div
                    onClick={() => showMessage(row.message)}
                    className="fw-600 text-primary cursor-pointer">
                    Lihat Pesan
                  </div>
                </td>
                <td className="text-left">
                  {format(new Date(row.created_at), 'dd/MM/yyyy HH:mm')}
                </td>
                <td className="text-center pe-0">
                  {row.is_approved != null ? null : (
                    // (
                    //   <button
                    //     onClick={() => handleUpdate(row.id, !row_is_approved)}
                    //     className={`fw-500 btn ${row.is_approved ? 'btn-danger text-white' : 'btn-success text-white'} btn-sm`}>
                    //     {row.is_approved ? 'Tolak' : 'Setuju'}
                    //   </button>
                    // ) :
                    <>
                      <button
                        onClick={() => handleUpdate(row.id, true)}
                        className="fw-500 btn btn-success text-white btn-sm">
                        Setuju
                      </button>
                      <button
                        onClick={() => handleUpdate(row.id, false)}
                        className="fw-500 btn btn-danger text-white btn-sm">
                        Tolak
                      </button>
                    </>
                  )}
                </td>
              </tr>
            ))}
        </tbody>
      </table>
      <Pagination
        currentPage={paginationOptions.page}
        totalRows={totalRows}
        rowsPerPage={paginationOptions.limit}
        onPageChange={handlePageChange}
      />
    </div>
  );
}

export default ReviewTable;
